import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Typography,
} from '@mui/material';

const numberFormatter = new Intl.NumberFormat('ro-RO', {
  maximumFractionDigits: 0,
});

function ValidationMetric({ label, metric, color, hasData, loading }) {
  const value = Number(metric?.value || 0);
  const share = metric?.share;
  const shareLabel = share === null || typeof share === 'undefined'
    ? '—'
    : `${Number(share).toFixed(1)}%`;

  return (
    <Box
      role="group"
      aria-label={`${label}: ${hasData ? numberFormatter.format(value) : 'not available'}, ${hasData ? shareLabel : 'not available'}`}
      sx={{
        minWidth: 0,
        pl: { xs: 0.8, sm: 1 },
        borderLeft: `3px solid ${color}`,
      }}
    >
      <Typography sx={{ color: '#475569', fontSize: { xs: '0.68rem', sm: '0.72rem' }, fontWeight: 700 }}>
        {label}
      </Typography>
      {loading && !hasData ? (
        <Skeleton width="72%" height={30} />
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', gap: { xs: 0.4, sm: 0.65 } }}>
          <Typography sx={{ color: '#0f172a', fontSize: { xs: '1rem', sm: '1.15rem' }, fontWeight: 850, lineHeight: 1.3 }}>
            {hasData ? numberFormatter.format(value) : '—'}
          </Typography>
          <Typography sx={{ color: '#64748b', fontSize: '0.68rem', fontWeight: 700, whiteSpace: 'nowrap' }}>
            {hasData ? shareLabel : '—'}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

function ClientsAccountValidation({ validation, status }) {
  const hasData = Boolean(validation);
  const loading = status === 'loading';

  return (
    <Card
      component="section"
      aria-labelledby="account-validation-heading"
      sx={{
        borderRadius: { xs: '14px', sm: '16px' },
        border: '1px solid rgba(15, 23, 42, 0.06)',
        boxShadow: '0 3px 12px rgba(15, 23, 42, 0.06)',
      }}
    >
      <CardContent sx={{ p: { xs: '12px !important', sm: '14px 16px !important' } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'minmax(180px, 0.8fr) minmax(0, 2fr)' },
            alignItems: 'center',
            gap: { xs: 1, sm: 1.5 },
          }}
        >
          <Box minWidth={0}>
            <Typography id="account-validation-heading" sx={{ color: '#111827', fontWeight: 800, fontSize: '0.92rem' }}>
              Account validation
            </Typography>
            <Typography sx={{ mt: 0.1, color: '#64748b', fontSize: '0.72rem' }}>
              Current status of selected registrations
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              gap: { xs: 0.75, sm: 1 },
              minWidth: 0,
            }}
          >
            <ValidationMetric
              label="Validated"
              metric={validation?.validated}
              color="#059669"
              hasData={hasData}
              loading={loading}
            />
            <ValidationMetric
              label="Not validated"
              metric={validation?.not_validated}
              color="#d97706"
              hasData={hasData}
              loading={loading}
            />
            <ValidationMetric
              label="Suspended"
              metric={validation?.suspended}
              color="#64748b"
              hasData={hasData}
              loading={loading}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default ClientsAccountValidation;
